export default "__VITE_ASSET__0746a34e__"